import { render, staticRenderFns } from "./RefNo.vue?vue&type=template&id=6bee58dc"
import script from "./RefNo.vue?vue&type=script&lang=js"
export * from "./RefNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports